import { useState, useEffect } from 'react';
import { useParams, useNavigate } from '@tanstack/react-router';
import { baseUrl } from '../config';
import { Button } from '../components/Button';

export default function VerifyEmail() {
  const params = useParams({}); // Get all params
  const token = params.token; // Access the specific token param
  const navigate = useNavigate();
  const [status, setStatus] = useState('verifying'); // verifying, success, error
  const [message, setMessage] = useState('');

  useEffect(() => {
    const verifyEmail = async () => {
      try {
        const response = await fetch(`${baseUrl}/api/1/auth/verify-email/${token}`);
        const data = await response.json();
        
        if (response.ok) {
          setStatus('success');
          setMessage('Your email has been verified successfully! You can now sign in.');
          // Redirect to sign in after 3 seconds
          setTimeout(() => {
            navigate({ to: '/sign-in' });
          }, 3000);
        } else {
          setStatus('error');
          setMessage(data.message || 'Verification failed. Please try again or request a new verification link.');
        }
      } catch (error) {
        setStatus('error');
        setMessage('An error occurred during verification. Please try again later.');
      }
    };

    verifyEmail();
  }, [token, navigate]); // Ensure token dependency is correct

  return (
    <div className="bg-background w-screen min-h-screen flex justify-center items-center px-4 py-10">
      <div className="bg-background-elevated p-8 md:p-10 rounded-xl shadow-sm hover:shadow-md transition-shadow duration-200 w-full max-w-md space-y-6 border border-border/60 text-center">
        <h1 className="text-2xl font-semibold text-foreground tracking-tight">Email Verification</h1>
        
        {status === 'verifying' && (
          <div className="space-y-4">
            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-accent mx-auto"></div>
            <p className="text-muted-foreground">Verifying your email...</p>
          </div>
        )}

        {status === 'success' && (
          <div className="space-y-4">
            <div className="mx-auto w-16 h-16 bg-success/10 rounded-full flex items-center justify-center">
              <svg className="h-10 w-10 text-success" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" />
              </svg>
            </div>
            <p className="text-foreground">{message}</p>
            <p className="text-sm text-muted-foreground">Redirecting to sign in...</p>
          </div>
        )}

        {status === 'error' && (
          <div className="space-y-4">
            <div className="mx-auto w-16 h-16 bg-danger/10 rounded-full flex items-center justify-center">
              <svg className="h-10 w-10 text-danger" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </div>
            <p className="text-muted-foreground">{message}</p>
            <Button
              onClick={() => navigate({ to: '/sign-in' })}
              className="w-full"
              size="lg"
            >
              Back to Sign In
            </Button>
          </div>
        )}
      </div>
    </div>
  );
} 